import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", {
  "class": "mb-8 text-3xl font-bold"
}, "Running Queues", -1);
var _hoisted_2 = {
  "class": "bg-white rounded-md shadow overflow-x-auto"
};
var _hoisted_3 = {
  "class": "w-full whitespace-nowrap"
};
var _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", null, [/*#__PURE__*/_createElementVNode("tr", {
  "class": "text-left font-bold"
}, [/*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6 px-6"
}, "Name"), /*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6 px-6"
}, "Expected Threads"), /*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6 px-6"
}, "Running Threads")])], -1);
var _hoisted_5 = {
  "class": "hover:bg-gray-100 focus-within:bg-gray-100"
};
var _hoisted_6 = {
  "class": "border-t"
};
var _hoisted_7 = {
  "class": "border-t"
};
var _hoisted_8 = {
  "class": "flex items-center px-6 py-4",
  tabindex: "-1"
};
var _hoisted_9 = {
  "class": "border-t"
};
var _hoisted_10 = {
  "class": "flex items-center px-6 py-4",
  tabindex: "-1"
};
var _hoisted_11 = /*#__PURE__*/_createElementVNode("h1", {
  "class": "mt-8 mb-8 text-3xl font-bold"
}, "Jobs Queues", -1);
var _hoisted_12 = {
  "class": "bg-white rounded-md shadow overflow-x-auto"
};
var _hoisted_13 = {
  "class": "w-full whitespace-nowrap"
};
var _hoisted_14 = /*#__PURE__*/_createElementVNode("thead", null, [/*#__PURE__*/_createElementVNode("tr", {
  "class": "text-left font-bold"
}, [/*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6 px-6"
}, "Name"), /*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6 px-6"
}, "Number of Jobs")])], -1);
var _hoisted_15 = {
  "class": "hover:bg-gray-100 focus-within:bg-gray-100"
};
var _hoisted_16 = {
  "class": "border-t"
};
var _hoisted_17 = {
  "class": "flex items-center px-6 py-4",
  tabindex: "-1"
};
var _hoisted_18 = {
  "class": "border-t"
};
var _hoisted_19 = {
  "class": "flex items-center px-6 py-4",
  tabindex: "-1"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_Head, {
    title: "System Health"
  }), _hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("table", _hoisted_3, [_hoisted_4, _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.queues, function (queue) {
    return _openBlock(), _createElementBlock("tr", _hoisted_5, [_createElementVNode("td", _hoisted_6, [_createElementVNode("div", {
      "class": _normalizeClass($options.getHealthClass(queue.queue_count, queue.actual_count)),
      tabindex: "-1"
    }, _toDisplayString(queue.name), 3)]), _createElementVNode("td", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(queue.queue_count), 1)]), _createElementVNode("td", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(queue.actual_count), 1)])]);
  }), 256))])])]), _hoisted_11, _createElementVNode("div", _hoisted_12, [_createElementVNode("table", _hoisted_13, [_hoisted_14, _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.jobs, function (job_queue) {
    return _openBlock(), _createElementBlock("tr", _hoisted_15, [_createElementVNode("td", _hoisted_16, [_createElementVNode("div", _hoisted_17, _toDisplayString(job_queue.queue), 1)]), _createElementVNode("td", _hoisted_18, [_createElementVNode("div", _hoisted_19, _toDisplayString(Number(job_queue.job_count).toLocaleString()), 1)])]);
  }), 256))])])])]);
}